import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeContentPipe } from './safe-content/safe-content.pipe';



@NgModule({
  declarations: [SafeContentPipe],
  imports: [
    CommonModule
  ],
  exports: [SafeContentPipe]
})
export class UtilitiesModule { }
